import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-373ef60e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "camera-popup",
  ref: "cameraPop"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "title-text" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.popupData.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.popupData.companyAddress), 1),
        _createElementVNode("div", {
          class: "iconfont icon-close close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelPop && _ctx.cancelPop(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cameraType), {
        ref: "cameraRef",
        popupData: _ctx.popupData
      }, null, 8, ["popupData"]))
    ])
  ], 512))
}